var camelizeRE = /[_-](\w)/g;
var hyphenateRE = /\B([A-Z])/g;
/**
 * 将下划线中划线连字符转成驼峰
 * @param str 字符串
 * @return 返回格式化后的字符
 */
export var camelize = function camelize(str) {
  return str.replace(camelizeRE, function (_, c) {
    return c.toUpperCase();
  });
};
/**
 * 将字符串首字母大写
 * @param str 字符串
 * @return 返回格式化后的字符
 */
export var capitalize = function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
/**
 * 将驼峰转化为连字符
 * @param str 字符串
 * @param hyphen 对应的连接符号，默认是_
 * @return 返回格式化后的字符
 */
export var hyphenate = function hyphenate(str) {
  var hyphen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';
  return str.replace(hyphenateRE, "".concat(hyphen, "$1")).toLowerCase();
};
/**
 * 将对象的 Key 由下划线中划线连字符转成驼峰
 * @param obj 要转换的对象
 * @returns 转换后的对象
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var camelizeObject = function camelizeObject(obj) {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var res = {};
  Object.keys(obj).forEach(function (key) {
    res[camelize(key)] = obj[key];
    if (Array.isArray(obj[key])) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      res[camelize(key)] = obj[key].map(function (item) {
        return camelizeObject(item);
      });
    }
    if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
      res[camelize(key)] = camelizeObject(obj[key]);
    }
  });
  return res;
};
/**
 * 将对象的 Key 由驼峰转成下划线或中划线连字符
 * @param obj 要转换的对象
 * @returns 转换后的对象
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var hyphenateObject = function hyphenateObject(obj) {
  var hyphen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';
  if (!obj || typeof obj !== 'object') {
    return obj;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var res = {};
  Object.keys(obj).forEach(function (key) {
    res[hyphenate(key, hyphen)] = obj[key];
    if (Array.isArray(obj[key])) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      res[hyphenate(key, hyphen)] = obj[key].map(function (item) {
        return hyphenateObject(item, hyphen);
      });
    }
    if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
      res[hyphenate(key, hyphen)] = hyphenateObject(obj[key], hyphen);
    }
  });
  return res;
};
export var parseUrl = function parseUrl() {
  var href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var base = arguments.length > 1 ? arguments[1] : undefined;
  var url = href;
  if (href.startsWith('/') && base) {
    url = "".concat(base).concat(href);
  }
  var URLInfoRegex = new RegExp(['^(https?:)//',
  // protocol
  '(([^:/?#]*)(?::([0-9]+))?)',
  // host (hostname and port)
  '(/{0,1}[^?#]*)',
  // pathname
  '(\\?[^#]*|)',
  // search
  '(#.*|)$' // hash
  ].join(''));
  var match = url.match(URLInfoRegex);
  return match ? {
    href: url,
    protocol: match[1],
    host: match[2],
    hostname: match[3],
    port: match[4],
    pathname: match[5],
    search: match[6],
    hash: match[7]
  } : {};
};